/* eslint-disable react-hooks/exhaustive-deps */
import { Card } from "../../../components/card.component";
import { ChangeEvent, useEffect, useState } from "react";
import searchIcon from "../../../assets/img/search-icon.svg";
import { useAppDispatch } from "../../../core/redux";
import { InsuranceList } from "../../../features/insurance/insuranceList.component";
import { ActionsInsuranceTable } from "../../../core/redux/slices/sliceInsuranceTable";
import { debounce } from "../../../utils";

export const PageInsuranceView = () => {
  const dispatch = useAppDispatch();
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
    debounce(() => {
      dispatch(ActionsInsuranceTable.goToPage(1));
      dispatch(ActionsInsuranceTable.setSearchKey(event.target.value));
    });
  };

  useEffect(() => {
    return () => {
      dispatch(ActionsInsuranceTable.resetData());
    };
  }, [dispatch]);

  return (
    <Card
      header={
        <div className="row align-items-center  justify-content-between">
          <div className="col-md-8 col-12 content-box-title">
            <div>
              <p className="text-capitalize my-1 text-green-200">
                Manage Insurance
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
          <div className="col-md-4 col-12 mt-1">
            <form className="search-component">
              <div className="input-group me-3">
                <span
                  className="input-group-text pe-2"
                  id="search-component-word"
                >
                  <img src={searchIcon} alt="search-icon" />
                </span>
                <input
                  type="text"
                  className="form-control ps-0"
                  placeholder="Search..."
                  aria-label="Search"
                  aria-describedby="search-component-word"
                  onChange={handleSearch}
                  value={searchValue}
                  onKeyPress={(ev) => {
                    ev.key === "Enter" && ev.preventDefault();
                  }}
                />
                {searchValue.length > 0 && (
                  <span
                    className="input-group-text text-green-200"
                    id="search-component-word"
                  >
                    <i
                      className="fas fa-times click"
                      onClick={() => {
                        setSearchValue("");
                        dispatch(ActionsInsuranceTable.setSearchKey(""));
                      }}
                    />
                  </span>
                )}
              </div>
            </form>
          </div>
        </div>
      }
    >
      <InsuranceList />
    </Card>
  );
};
